import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { phoneInput, emailInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import FocusTrapUtility from '@sparta.global.utilities/focus-trap-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import SpartaBrowserSupportUtility from '@sparta.global.utilities/sparta-browser-support-utility/dist/es6.js';
import SpartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import SpartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import SpartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section\r\n        id=\""
    + container.escapeExpression(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"\r\n        "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias2,(depth0 != null ? lookupProperty(depth0,"id") : depth0),"===","other",{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":38,"column":81}}})) != null ? stack1 : "")
    + "\r\n      >\r\n        <div class=\"row\">\r\n          <div class=\"column\">\r\n            <h5 data-font=\"cnx-regular\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"appStoreImage") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":12},"end":{"line":57,"column":19}}})) != null ? stack1 : "")
    + "\r\n            <p class=\"disclaimer\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"learnMoreLink") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":12},"end":{"line":65,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"contactSection") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":12},"end":{"line":69,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"contactSection") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":8},"end":{"line":124,"column":15}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"deviceDisclaimer") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":126,"column":8},"end":{"line":132,"column":15}}})) != null ? stack1 : "")
    + "      </section>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "class=\"with-bottom-padding\"";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a\r\n                href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"appStoreUrl") : stack1), depth0))
    + "\"\r\n                class=\"app-store-download-link\"\r\n                id=\"appStoreDownloadLink"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"deviceType") : depth0), depth0))
    + "\"\r\n              >\r\n                <img\r\n                  class=\"app-store-image\"\r\n                  src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"appStoreImage") : stack1), depth0))
    + "\"\r\n                  alt=\""
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"appStoreImageAlt") : stack1), depth0)) != null ? stack1 : "")
    + "\"\r\n                  role=\"img\"\r\n                />\r\n              </a>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a href=\""
    + container.escapeExpression(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"learnMoreLink") : stack1), depth0))
    + "\">\r\n                "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"downloadSection") : depth0)) != null ? lookupProperty(stack1,"learnMoreLinkText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              </a>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <h5 data-font=\"cnx-regular\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"contactSection") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <form name=\"getAppDeviceForm\" autocomplete=\"off\" novalidate>\r\n            <div class=\"row spa-input-btn-group\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias1,(depth0 != null ? lookupProperty(depth0,"action") : depth0),"==","sms",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":76,"column":14},"end":{"line":108,"column":26}}})) != null ? stack1 : "")
    + "            </div>\r\n            <div class=\"row hide validation-error\">\r\n              <div class=\"column\">\r\n                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"contactSection") : depth0)) != null ? lookupProperty(stack1,"validationError") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              </div>\r\n            </div>\r\n          </form>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"contactSection") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":117,"column":10},"end":{"line":123,"column":17}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"column medium-6\">\r\n                  "
    + ((stack1 = (lookupProperty(helpers,"phoneInput")||(depth0 && lookupProperty(depth0,"phoneInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"phoneNumberField") : depth0),{"name":"phoneInput","hash":{},"data":data,"loc":{"start":{"line":78,"column":18},"end":{"line":78,"column":56}}})) != null ? stack1 : "")
    + "\r\n                </div>\r\n                <div class=\"column medium-6 form-action spa-input-btn-column\">\r\n                  <button\r\n                    class=\"spa-btn spa-btn--primary spa-btn--medium choice-submit\"\r\n                    data-action-type=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"action") : depth0), depth0))
    + "\"\r\n                    data-device-type=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"deviceType") : depth0), depth0))
    + "\"\r\n                    type=\"submit\"\r\n                    id=\"sendToDeviceBtn"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"deviceType") : depth0), depth0))
    + "\"\r\n                  >\r\n                    "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"data"))) && lookupProperty(stack1,"buttons"))) && lookupProperty(stack1,"submitContact")), depth0)) != null ? stack1 : "")
    + "\r\n                    <span class=\"spin\"></span>\r\n                  </button>\r\n                </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"column medium-8\">\r\n                  "
    + ((stack1 = (lookupProperty(helpers,"emailInput")||(depth0 && lookupProperty(depth0,"emailInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"data"))) && lookupProperty(stack1,"emailAddressField")),{"name":"emailInput","hash":{},"data":data,"loc":{"start":{"line":94,"column":18},"end":{"line":94,"column":63}}})) != null ? stack1 : "")
    + "\r\n                </div>\r\n                <div class=\"column medium-4 form-action spa-input-btn-column\">\r\n                  <button\r\n                    class=\"spa-btn spa-btn--primary spa-btn--medium choice-submit\"\r\n                    data-action-type=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"action") : depth0), depth0))
    + "\"\r\n                    data-device-type=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"deviceType") : depth0), depth0))
    + "\"\r\n                    type=\"submit\"\r\n                    id=\"sendToDeviceBtn"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"deviceType") : depth0), depth0))
    + "\"\r\n                  >\r\n                    "
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"data"))) && lookupProperty(stack1,"buttons"))) && lookupProperty(stack1,"submitContact")), depth0)) != null ? stack1 : "")
    + "\r\n                    <span class=\"spin\"></span>\r\n                  </button>\r\n                </div>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"row\">\r\n              <div class=\"column\">\r\n                <p class=\"disclaimer contact-section\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"contactSection") : depth0)) != null ? lookupProperty(stack1,"disclaimer") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n              </div>\r\n            </div>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"row\">\r\n            <div class=\"column small-collapse\">\r\n              <p class=\"disclaimer trademark-disclosure\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"deviceDisclaimer") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n            </div>\r\n          </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div\r\n  id=\"globalGetAppModalContent\"\r\n  class=\"hide\"\r\n  data-options='{\"type\":\"modal\"}'\r\n  data-modal-close-txt='{\"default\": \""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"closeAdaTextSpacer") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0))
    + "\", \"device\": \""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"closeAdaTextSpacer") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"interstitial") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0))
    + "\"}'\r\n>\r\n  <div id=\"modal-title-get-app\" class=\"row\">\r\n    <div class=\"column\">\r\n      <h4 class=\"title\" data-font=\"cnx-regular\">"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"content\">\r\n    <form\r\n      id=\"getAppDeviceForm\"\r\n      name=\"getAppDeviceForm\"\r\n      autocomplete=\"off\"\r\n      novalidate\r\n    >\r\n      <div class=\"row spa-input-btn-group\">\r\n        <div class=\"column medium-6\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"deviceField") : stack1),{"name":"select","hash":{},"data":data,"loc":{"start":{"line":22,"column":10},"end":{"line":22,"column":39}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n        <div class=\"column medium-6 form-action spa-input-btn-column\">\r\n          <button\r\n            class=\"spa-btn spa-btn--medium spa-btn--primary\"\r\n            id=\"appChoiceSubmit\"\r\n            role=\"button\"\r\n            type=\"submit\"\r\n          >"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1)) != null ? lookupProperty(stack1,"chooseDevice") : stack1), depth0)) != null ? stack1 : "")
    + "</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"devices") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":4},"end":{"line":134,"column":13}}})) != null ? stack1 : "")
    + "\r\n    <section id=\"interstitial\" class=\"row\">\r\n      <div id=\"modalContentInt\" class=\"column\">\r\n        <h3 data-font=\"cnx-regular\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"interstitial") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h3>\r\n        <div class=\"content\">\r\n          <p>"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"interstitial") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n          <p class=\"spa-btn-group\">\r\n            <a\r\n              class=\"spa-btn spa-btn--small spa-btn--primary\"\r\n              id=\"continue-link\"\r\n            >\r\n              "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1)) != null ? lookupProperty(stack1,"interstitialContinue") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </a>\r\n            <button\r\n              type=\"button\"\r\n              class=\"spa-btn spa-btn--small spa-btn--secondary confirm-action-complete\"\r\n            >\r\n              "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1)) != null ? lookupProperty(stack1,"interstitialBack") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </button>\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </section>\r\n\r\n    <section id=\"sendToDeviceSuccess\" class=\"with-bottom-padding\">\r\n      <h4 class=\"title\" data-font=\"cnx-regular\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"success") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n      <div class=\"content with-icon success-icon\">\r\n        <p class=\"emailAction hide\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"success") : stack1)) != null ? lookupProperty(stack1,"emailContent") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n        <p class=\"textAction hide\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"success") : stack1)) != null ? lookupProperty(stack1,"textContent") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n      </div>\r\n      <div class=\"primary-action\">\r\n        <button\r\n          type=\"button\"\r\n          class=\"spa-btn spa-btn--small spa-btn--primary confirm-action-complete\"\r\n        >\r\n          "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1)) != null ? lookupProperty(stack1,"success") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </button>\r\n      </div>\r\n    </section>\r\n\r\n    <section id=\"sendToDeviceError\" class=\"with-bottom-padding\">\r\n      <div class=\"row\">\r\n        <div class=\"column\">\r\n          <h4 class=\"title\" data-font=\"cnx-regular\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"error") : stack1)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h4>\r\n          <div class=\"content with-icon error-icon\">"
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"error") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"primary-action\">\r\n            <button\r\n              type=\"button\"\r\n              class=\"spa-btn spa-btn--small spa-btn--primary confirm-action-complete\"\r\n            >\r\n              "
    + ((stack1 = alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"buttons") : stack1)) != null ? lookupProperty(stack1,"error") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/get-app-modal-module",
  "version": "1.1.18",
  "id": "getAppModalModule",
  "containerID": "globalGetAppModalModule",
  "moduleName": "global-get-app-modal-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "get-app-modal-module",
  "data": {
    "init": "GetAppModalModule",
    "options": {
      "bypassInterstitalDesktop": "{{module.bypassInterstitalDesktop}}",
      "data1": "{{json data}}"
    }
  },
  "moduleParams": [{
    "name": "bypassInterstitalDesktop",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "If you are on the desktop environment and you are already displaying the proper legal verbiage, this will skip the interstitial for the app store links."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        select,
        emailInput,
        phoneInput
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    select,
    emailInput,
    phoneInput
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.5",
    "@sparta.global.helpers/select-helper": "^1.1.9",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.22",
    "@sparta.global.utilities/focus-trap-utility": "^1.0.29",
    "@sparta.global.utilities/sparta-browser-support-utility": "^1.0.12",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.22",
    "@sparta.global.utilities/sparta-input-utility": "^1.2.31",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.16",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.6",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.4",
    "@sparta.global.utilities/sparta-spacing-style-token-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-breakpoint-style-token-utility": "^1.0.2",
    "@sparta.global.utilities/sparta-font-style-token-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.1.48",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.19",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.5.1"
  },
  "stores": []
};

/* eslint-disable
import/no-unresolved,
import/first,
no-unused-vars,
no-underscore-dangle,
require-jsdoc
*/

const EVENTS = {
  OPEN: 'OPEN.globalGetAppModal',
  MODAL_CLOSE: 'MODAL_CLOSE.SpartaUILayersUtility'
};
class GetAppModalModule extends Module {
  constructor(options, context) {
    options.target = '#globalGetAppModalContent'; // eslint-disable-line no-param-reassign
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {
    this.$target = this.settings.$target;
    // this.$target.spartaInputs(inputSettings);
    this.browserInfo = SpartaBrowserSupportUtility.boaBrowserSystemCheck();
    this._bindInputs();
    this._bindWindowEvents();
    this._onAppChoice();
    this._onChoiceSubmit();
    this._interstitalFunctions();
    this._bindEvents();
  }
  _interstitalFunctions() {
    this.$target.find('.app-store-download-link').on('click', e => {
      if (this.browserInfo.desktop) {
        if (this.settings.bypassInterstitalDesktop === 'false') {
          this._interstitalShow(e.currentTarget);
          e.preventDefault();
        }
      }
    });
    this.$target.find('.confirm-action-complete').on('click', e => {
      SpartaUILayersUtility.closeLayer();
      e.preventDefault();
    });
  }
  _onAppChoice() {
    const select = document.getElementById('getAppDeviceSelect');

    // Fix iOS bug where select menus lose focus after selection.
    // This bug causes the focus-trap utility to display the "Beginning of Layer" label.
    this.Events.sub(FocusTrapUtility.EVENTS.FOCUSOUT, ({
      data
    }) => {
      if (data.event.target === select) {
        // iPad is the cool kid by having a different select menu UI,
        // which messes with focus even more.
        if (this.browserInfo.ipad) {
          if (!Element.prototype.closest) return;
          const selectContainer = select.closest('.spa-dropdown');
          selectContainer.setAttribute('tabindex', '-1');
          selectContainer.focus(); // if focus is put back on select, user cannot reselect
          return;
        }
        select.focus();
      }
    });
    select.addEventListener('change', e => {
      if ($(e.currentTarget).value !== '') {
        this.$target.find('section.open').slideUp(250, () => {
          $(e.currentTarget).removeClass('open');
        });
      }
    });
    const {
      cmClick
    } = this;
    const self = this;
    $(this.eventDelegatorString).on('click', '#appChoiceSubmit', e => {
      e.preventDefault();
      cmClick(e.target.id);
      const isValidRequired = SpartaValidationFramework.fn.core.validateRequiredFields($(e.currentTarget).closest('form').find('[required]:visible'));
      if (!isValidRequired) return;
      const selectVal = document.getElementById('getAppDeviceSelect').value;
      const $openSection = self.$target.find('section.open');
      const selector = `section#${selectVal}`;

      // set the appstore url link
      self.$target.find('.app-store-download-link').data('app-store-link', selectVal);

      // Update inline error
      const inputMap = {
        '.js-phoneNumberField': 'phoneNumberField',
        '#emailAddressField': 'emailAddressField'
      };
      Object.keys(inputMap).forEach(input => {
        const $input = self.$target.find(input);
        const $label = $input.siblings('label');
        SpartaInputErrorUtility.updateInlineError(false, {
          field: $input,
          label: $label
        });
      });

      // animate object & finished function 250ms
      if ($openSection.length) {
        $openSection.slideUp(250, function getAppOpen() {
          $(this).removeClass('open');
          $(selector).slideDown(250, function getAppSlideDown() {
            $(this).addClass('open');
          });
        });
      } else {
        $(selector).slideDown(250, function getAppSlideDown() {
          $(this).addClass('open');
        });
      }
    });
  }
  _onChoiceSubmit() {
    // On enter, trigger click - coremetrics compatible
    this.$target.find('form').on('submit.getAppSubmit', e => {
      e.preventDefault();
      $(e.currentTarget).find('.choice-submit').click();
    });
    const {
      cmClick
    } = this;
    this.$target.find('.choice-submit').on('click.getAppSubmit', e => {
      // parse up through this form and get what we need
      const $this = $(e.currentTarget);
      const endPoint = spaParams.siteParams.getAppService;
      let $data;
      cmClick(e.target.id);
      const reqFields = $this.closest('form').find('[required]:visible');
      const isValidRequired = SpartaValidationFramework.fn.core.validateRequiredFields(reqFields);
      if (!isValidRequired) return;

      // real quick front end validation for phone length and 'valid' email
      if ($this.data('action-type') === 'sms') {
        $data = $this.parent().prev().find('.js-phoneNumberField');
      } else {
        $data = $('#emailAddressField');
      }
      $data.trigger('change'); // Due to submit on enter.

      const changeRules = $data.data('validationRules').change;
      const isValidRules = SpartaValidationFramework.fn.core.validateRules($data, changeRules);
      if (!isValidRules) return;

      // do the ajax request
      const contactAddress = $data.val();
      const dataObj = {
        deviceType: $this.data('device-type'),
        communicationAddress: '',
        communicationMethod: ''
      };
      // if we're texting it should be a phone number,
      // so remove all the non-numeric characters per endpoint guidelines
      if ($this.data('action-type') === 'sms') {
        dataObj.communicationAddress = contactAddress.replace(/\D/g, '');
        dataObj.communicationMethod = 'TEXT';
      } else {
        dataObj.communicationAddress = contactAddress;
        dataObj.communicationMethod = 'EMAIL';
      }
      const headers = {};
      const csrfToken = spartaStoreUtility.getData('csrfToken');
      if (csrfToken) {
        headers.csrfToken = csrfToken;
      }
      $.ajax({
        type: 'POST',
        url: endPoint,
        data: `{"communicationAddress":"${dataObj.communicationAddress}","deviceType":"${dataObj.deviceType}","communicationMethod":"${dataObj.communicationMethod}"}`,
        contentType: 'application/json',
        headers,
        beforeSend: () => {
          $this.find('.spin').addClass('spinner');
        },
        success: () => {
          const $sendToDeviceSuccess = $('#sendToDeviceSuccess');
          const $emailAction = $sendToDeviceSuccess.find('.emailAction');
          const $textAction = $sendToDeviceSuccess.find('.textAction');
          if ($this.data('action-type') === 'sms') {
            $emailAction.addClass('hide');
            $textAction.removeClass('hide');
          } else {
            $textAction.addClass('hide');
            $emailAction.removeClass('hide');
          }
          $('#getAppDeviceForm, #modal-title-get-app').slideUp();
          this.$target.find('section.open').slideUp(250, () => {
            $sendToDeviceSuccess.find('.destination').text($data.val());
            $sendToDeviceSuccess.slideDown(function slideDownAddClass() {
              $(this).addClass('open');
            });
          });
          const success = document.querySelector('#globalGetAppModalContentSpartaUILayer .success-icon');
          if (success) {
            success.style.backgroundImage = `url(${this.settings.data1.success.icon})`;
          }
        },
        error: () => {
          $('#getAppDeviceForm, #modal-title-get-app').slideUp();
          this.$target.find('section.open').slideUp(250, () => {
            $('#sendToDeviceError').slideDown(function slideDownAddClass() {
              $(this).addClass('open');
            });
          });
          const error = document.querySelector('#globalGetAppModalContentSpartaUILayer .error-icon');
          const errorValidate = document.querySelector('#globalGetAppModalContentSpartaUILayer .validation-error');
          if (error || errorValidate) {
            error.style.backgroundImage = `url(${this.settings.data1.error.icon})`;
            errorValidate.style.backgroundImage = `url(${this.settings.data1.error.icon})`;
          }
        },
        complete: () => {
          $this.find('.spin').removeClass('spinner');
        }
      });
      e.preventDefault();
    });
  }
  _interstitalShow(appStoreUrl = '') {
    // we've equaled none of the devices and we're not on desktop
    if (appStoreUrl === '' && this.browserInfo.desktop === false) {
      window.location.href = '/online-banking/iphone-banking-app.go';
    }
    $('#continue-link').attr('href', appStoreUrl);
    $('#getAppDeviceForm, #modal-title-get-app').hide();
    $('section.open', this.$target).hide(0);
    $('#interstitial').slideDown(250, () => {
      $(this).addClass('open');
      $('.spa-ui-modal').addClass('spa-ui-modal-interstitial');
    });
    return false;
  }
  _openGetAppModal(event) {
    const kindleStrings = ['Kindle', 'KFTT', 'KFOT', 'KFJWA', 'KFJWI', 'KFSOWI', 'KFTHWA', 'KFTHWI', 'KFAPWA', 'KFAPWI', 'KFASWI', 'KFTBWI', 'KFMEWI', 'KFFOWI', 'KFSAWA', 'KFSAWI', 'KFARWI'];
    let isKindle = false;
    let matchRegExp = '';
    for (let index = 0; index < kindleStrings.length; index += 1) {
      matchRegExp = new RegExp(kindleStrings[index]);
      if (matchRegExp.test(this.browserInfo.ua)) {
        isKindle = true;
        break;
      }
    }
    if (isKindle) {
      window.location.href = '/online-banking/iphone-banking-app.go';
      return;
    }
    this.resetForm();
    SpartaUILayersUtility.openLayer(this.$target, event, null, this.widgetInfo?.id);

    // In IE, rendering the <select> causes it to default its value to the first <option>,
    // so set it blank again
    if (this.browserInfo.msie || this.browserInfo.safari) {
      $('select', this.$target).val('');
    }

    // update modal close button for ADA on non-mobile
    this._updateModalADAText();
    let appStoreUrl = '';
    if (this.browserInfo.iphone) {
      const anchor = $('section#iphone-get-app .app-store-download-link', this.$target);
      appStoreUrl = anchor.attr('href');
      this._interstitalShow(appStoreUrl);
    }
    if (this.browserInfo.ipad) {
      const anchor = $('section#ipad-get-app .app-store-download-link', this.$target);
      appStoreUrl = anchor.attr('href');
      this._interstitalShow(appStoreUrl);
    }
    if (this.browserInfo.android) {
      const anchor = $('section#android-get-app .app-store-download-link', this.$target);
      appStoreUrl = anchor.attr('href');
      this._interstitalShow(appStoreUrl);
    }
  }

  /**
   * Updates the DESKTOP [X] close button for modal
   */
  _updateModalADAText() {
    // get string options from data attr
    let adaText = this.$target.attr('data-modal-close-txt');
    adaText = JSON.parse(adaText);

    // set strings
    const textDefault = adaText.default;
    const textDeviceTxt = adaText.device;

    // get target element
    const modalCloseBtn = this.$target.closest('.spa-content').find('.spa-ui-layer-close .ada-hidden');
    if (!this.browserInfo.iphone && !this.browserInfo.ipad && !this.browserInfo.android) {
      // Default text: if not using iPhone, iPad, or Android.
      modalCloseBtn.text(textDefault);
    } else if (this.browserInfo.iphone || this.browserInfo.ipad || this.browserInfo.android) {
      // Device text: else if using iPhone, iPad, or Android.
      modalCloseBtn.text(textDeviceTxt);
    }
  }

  /**
   * @deprecated Left for backwards compatibility. @see _bindEvents pub sub event.
   * @returns {void}
   */
  _bindWindowEvents() {
    // bind a custom event to the window so that other elements can trigger it
    $(window).on('getAppModal:open', this._openGetAppModal.bind(this));

    // for dev purposes
    // $(window).trigger('getAppModal:open');
  }

  /**
   * It's recommended to use this event since click event to ui layers will fail and the original
   * click event will lose focus (ADA req).
   * @returns {void}
   */
  _bindEvents() {
    this.Events.sub(EVENTS.OPEN, resp => {
      this._openGetAppModal(resp.data);
    }, true);
    this.Events.sub(EVENTS.MODAL_CLOSE, () => {
      this.resetForm();
    }, true);
  }
  _bindInputs() {
    this.settings.$target.spartaInputs({
      validate: true
    });
    const validations = {};
    this.settings.$target.find('[data-validation-rules]').each(function eachInputRule() {
      const $this = $(this);
      validations[$this.attr('id')] = $this.data('validation-rules');
    });
    SpartaValidationFramework.init();
    SpartaValidationFramework.fn.core.bindValidationRules(validations, true);
  }
  resetForm() {
    // empty all the inputs
    $('input', this.$target).val('');
    $('#getAppDeviceSelect', this.$target).val('').parent().removeClass('spa-input--focused').addClass('spa-input--empty');

    // close all the sections
    this.$target.find('section.open').hide(0);
    $('#modal-title-get-app').show();
    $('#getAppDeviceForm').show();
  }

  /* eslint-disable class-methods-use-this, no-undef */
  cmClick(action) {
    if (typeof bactm !== 'undefined') {
      if (Object.prototype.hasOwnProperty.call(bactm, 'manualLinkClick')) {
        bactm.manualLinkClick('javascript:void(0);', action); // eslint-disable-line no-script-url
      }
    }
  }
  /* eslint-enable class-methods-use-this, no-undef */
}
registerModuleClass({
  moduleClass: GetAppModalModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GetAppModalModule as default, moduleConfig };
